module.exports = __webpack_public_path__ + "static/media/swot.1d763864.jpeg";